import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import store from '../../store'
import router from '../../router'

export default {
  namespaced: true,
  state () {
    return {
      init: false,
      user: null,
      reference: null
    }
  },
  getters: {
    init (state) {
      return state.init
    },
    user (state) {
      return state.user
    },
    reference (state) {
      return state.reference
    }
  },
  mutations: {
    init (state, payload) {
      state.init = payload
    },
    initUser (state) {
      state.user = null
    },
    updateUser (state, payload) {
      state.user = payload
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({commit}, payload) {
      commit('init', payload)
    },
    authState ({commit}) {
      var vm = this
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          store.dispatch('dispatch/setAuth', true)
          const db = firebase.firestore()
          const settings = { timestampsInSnapshots: true }
          db.settings(settings)
          var docRef = db.collection('users').doc(user.uid)
          docRef.get().then(function (doc) {
            if (doc.exists) {
              const payload = {
                key: doc.id,
                role: doc.data().role,
                services: doc.data().services,
                groups: doc.data().groups,
                name: doc.data().name,
                email: doc.data().email,
                icon: doc.data().icon,
                status: doc.data().status,
                routine: doc.data().routine,
                enable: doc.data().enable,
                option: doc.data().option,
                createdAt: doc.data().createdAt,
                updatedAt: doc.data().updatedAt
              }
              commit('updateUser', payload)
              store.dispatch('register/register', true)
            } else {
              var unwatch = vm.watch(state => vm.getters['register/register'], value => {
                unwatch()
                if (value) {
                  var docRef = db.collection('users').doc(user.uid)
                  docRef.get().then(function (doc) {
                    if (doc.exists) {
                      const payload = {
                        key: doc.id,
                        role: doc.data().role,
                        services: doc.data().services,
                        groups: doc.data().groups,
                        name: doc.data().name,
                        email: doc.data().email,
                        icon: doc.data().icon,
                        status: doc.data().status,
                        routine: doc.data().routine,
                        enable: doc.data().enable,
                        option: doc.data().option,
                        createdAt: doc.data().createdAt,
                        updatedAt: doc.data().updatedAt
                      }
                      commit('updateUser', payload)
                      store.dispatch('register/register', true)
                    }
                  })
                }
                store.dispatch('register/register', true)
              })
            }
          })
        } else {
          store.dispatch('dispatch/setAuth', false)
          store.dispatch('dispatch/setLoading', false)
          router.push('/login')
        }
      })
    },
    initUser ({ commit }) {
      commit('initUser')
    },
    updateUser ({ commit }) {
      return new Promise((resolve, reject) => {
        const payload = firebase.auth().currentUser
        if (!payload) {
          resolve()
        }
        const db = firebase.firestore()
        const settings = { timestampsInSnapshots: true }
        db.settings(settings)
        var docRef = db.collection('users').doc(payload.uid)
        docRef.get().then(function (doc) {
          if (!doc.exists) {
            resolve()
          } else {
            var reference = docRef.onSnapshot(function (doc) {
              const payload = {
                key: doc.id,
                role: doc.data().role,
                services: doc.data().services,
                groups: doc.data().groups,
                // services: JSON.parse(JSON.stringify(doc.data().services)),
                // groups: JSON.parse(JSON.stringify(doc.data().groups)),
                name: doc.data().name,
                email: doc.data().email,
                icon: doc.data().icon,
                status: doc.data().status,
                routine: doc.data().routine,
                enable: doc.data().enable,
                option: doc.data().option,
                // option: JSON.parse(JSON.stringify(doc.data().option)),
                createdAt: doc.data().createdAt,
                updatedAt: doc.data().updatedAt
              }
              commit('updateUser', payload)
              resolve()
            })
            commit('reference', reference)
          }
        })
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['authUser/reference']
      return new Promise((resolve, reject) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('initUser')
          resolve()
        } else {
          resolve()
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/AuthUser.js